<section class="cta-banner">

    <div class="cta-banner__overlay"></div>

    <div class="container-redesign">

        <div class="cta-banner__content">

            <h2 class="cta-banner__title">
                Ready to move from reactive
                <span>mental healthcare</span>
                to proactive prevention?
            </h2>

            <div class="cta-banner__actions">

                <a
                    routerLink="/contact-redesign"
                    class="cta-banner__button cta-banner__button--primary">

                    <span>TALK TO OUR TEAM</span>

                    <img
                        src="/assets/img/redesign/flecha.svg"
                        alt=""
                        class="cta-banner__button-icon">

                </a>

                <a
                    href="https://system.demo.myaltheasoft.com"
                    class="cta-banner__button cta-banner__button--secondary">

                    PLATFORM DEMO

                </a>

            </div>

            <p class="cta-banner__note">
                No obligation
                <span></span>
                Built for healthcare professionals
            </p>

        </div>

    </div>

</section>